import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

import ExampleImg from '../../examples-util/nucleus.png';

const AvatarLargeExample = (): React.JSX.Element => {
	return (
		<div>
			<Avatar
				size="large"
				src="https://pbs.twimg.com/profile_images/803832195970433027/aaoG6PJI_400x400.jpg"
				name="Scott Farquhar"
			/>
			<Avatar size="large" appearance="square" src={ExampleImg} name="Nucleus" />
			<Avatar size="large" appearance="hexagon" src={ExampleImg} name="Nucleus" />
		</div>
	);
};

export default AvatarLargeExample;
